import { useTranslation } from 'react-i18next'
import IWButton from 'shared/components/thunderbolt/IWButton'
import IWModal, {
  IWModalContent,
  IWModalFooter,
  IWModalHeader,
} from 'shared/components/thunderbolt/IWModal'
import IWTypography from 'shared/components/thunderbolt/IWTypography'
import styled from 'styled-components'

const StyledModalFooter = styled(IWModalFooter)`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 0.5rem;
`

type Props = {
  isModalOpen: boolean
  ibtContractId?: string
  onCancel: () => void
  onDelete: (id?: string) => void
}

const DeleteIbtContractModal = ({
  isModalOpen,
  ibtContractId,
  onCancel,
  onDelete,
}: Props) => {
  const { t } = useTranslation()

  const handleOnClose = () => {
    onCancel()
  }

  const handleOnDelete = () => {
    onDelete(ibtContractId)
  }

  return (
    <IWModal open={isModalOpen} onClose={handleOnClose}>
      <IWModalHeader>
        <IWTypography size="lg" weight="medium">
          {t('loadScheduling.titles.adminIbtContractDelete')}
        </IWTypography>
      </IWModalHeader>
      <IWModalContent>
        <IWTypography size="sm" fontHue={{ color: 'grey', value: 500 }}>
          {t('loadScheduling.descriptions.adminIbtContractDelete', {
            ibtContractId,
          })}
        </IWTypography>
      </IWModalContent>
      <StyledModalFooter>
        <IWButton color="grey" variant="outline" onClick={handleOnClose}>
          {t('button.cancel')}
        </IWButton>
        <IWButton
          color="alert"
          disabled={!ibtContractId}
          onClick={handleOnDelete}
        >
          {t('button.delete')}
        </IWButton>
      </StyledModalFooter>
    </IWModal>
  )
}

export default DeleteIbtContractModal
